import React, { useState } from 'react'
import '../Navbar/Navbar.css'
import Logo from '../Images/logo.png'
import { Link } from 'react-router-dom'
import { FaBars, FaTimes, FaShoppingCart, FaSearch } from 'react-icons/fa';
import { useCart } from "react-use-cart";


export const Navbar = () => {

  const [icon, setIcon] = useState(false)
  const handleClick = () => {
    setIcon(!icon)
  }

  const closeSideDrawer = () => {
    setIcon(false)
  }

  const {
    isEmpty,
    totalItems,
  } = useCart();

  return (
    <div className='header'>
      <Link to='/' className='nav-logo' onClick={closeSideDrawer}><img src={Logo} alt="" /></Link>

      <div className='searchbar'>
        <input type="text" placeholder='Search...' />
        <i><FaSearch /></i>
      </div>

      <div>
        <ul className={icon ? 'nav-menu active' : 'nav-menu'}>
          <li><Link to='/' onClick={closeSideDrawer} className='nav-links'>Home</Link></li>
          <li><Link to='/vegetables' onClick={closeSideDrawer} className='nav-links'>Vegetables</Link></li>
          <li><Link to='/fruits' onClick={closeSideDrawer} className='nav-links'>Fruits</Link></li>
          <li><Link to='/cart' onClick={closeSideDrawer} className='nav-links carticon'><i><FaShoppingCart /></i>{!isEmpty && <span>{totalItems}</span>}</Link></li>
        </ul>
      </div>

      <div className='menu-icon' onClick={handleClick}>{icon ? <FaTimes className='fa-times'></FaTimes> : <FaBars className='fa-bars'></FaBars>}
      </div>



    </div>
  )
}
